module.exports = __webpack_public_path__ + "img/tuiguang3-2-2.8616b44e.png";